// import _ from "lodash"
import React from 'react';
import PropTypes from 'prop-types';
import { ButtonGroup } from '@tencent/spaui';
// import { enumMessages } from "@/utils/MessageUtils"

const data = [
  { label: '新开户', value: 'REGISTRATION_NEW' },
  // { label: '已有账户', value: 'REGISTRATION_EXISTED' },
];

class RegistrationTypeSelect extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }

  render() {
    const { value = 'REGISTRATION_NEW', onChange, onClear, disabled } = this.props

    // let data = _.map(enumMessages("RegistrationType"), (message) => {
    //   return {
    //     value: message.value,
    //     label: message.message,
    //   }
    // })
    // data = _.compact(data)

    return <ButtonGroup data={data} value={value} onChange={onChange} disabled={disabled} activeDisplayType="primary" />
  }
}
export default RegistrationTypeSelect;
